<template>
    <div class='log h-full'>
        <v-card class="h-full">
            <div class="search-box h-full">
                <div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
                    <img src="@/assets/img/border.png" alt="">
                    <span>{{$t('log.title')}}</span>
                </div>
                <div class="box">
                    <v-row class="px-2 ma-0">
                        <v-col cols="12" md="2">
                            <div class="s-list">
                                <v-select
                                    v-model="objData.type"
                                    dense
                                    :items="selectType"
                                    item-value="key"
                                    item-text="value"
                                    :label="$t('log.type')"
                                    outlined
                                    clearable
                                    hide-details="auto"
                                    :menu-props="{bottom:true,offsetY:true}">
                                </v-select>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="s-list">
                                <v-select
                                    v-model="objData.result"
                                    dense
                                    :items = "resultType"
                                    item-value="key"
                                    item-text="value"
                                    :label="$t('log.result')"
                                    outlined
                                    clearable
                                    hide-details="auto"
                                    :menu-props="{bottom:true,offsetY:true}">
                                </v-select>
                                <!-- <a-input class="select-flex" placeholder="请输入" v-model="objData.result"/> -->
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="s-list">
                                <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="datePicker.startTime"
                                            :label="$t('log.startTime')"
                                            readonly
                                            outlined
                                            dense
                                            hide-details="auto"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="datePicker.startTime"
                                        no-title
                                        :allowed-dates="allowedStartDates"
                                        scrollable
                                        @input="menu2 = false"
                                        :locale="lang"
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="s-list">
                                <v-menu
                                    v-model="menu1"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="datePicker.endTime"
                                            :label="$t('log.endTime')"
                                            readonly
                                            outlined
                                            dense
                                            hide-details="auto"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="datePicker.endTime"
                                        @input="menu1 = false"
                                        :allowed-dates="allowedEndDates"
                                        no-title
                                        scrollable
                                        :locale="lang"

                                    >
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4" lg="3" xl="3" sm="4">
                            <v-btn color="primary" @click="handleSearch">
                                {{$t('btn.search')}}
                            </v-btn>
                            <v-btn style="margin-left: 8px" outlined @click="handleReset">
                                {{$t('btn.reset')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div class="table-box">
                    <v-data-table
                        fixed-header
                        class="table-style"
                        dense
                        size="small"
                        :headers="columns"
                        :style="{'height': $vuetify.breakpoint.mdAndDown ? 'auto' : dataSource.length >= 1 ? 'calc(100vh - 250px)': 'auto'}"
                        no-data-text=""
                        :loading="spinning"
                        :items="dataSource"
                        :server-items-length="TableTotal"
                        :footer-props="{'items-per-page-options':[10, 20, 50, 100],'items-per-page-text': $t('pagination.perPage'),'page-text': `{0}-{1} ${this.$t('pagination.aggregate')} {2}`}"
					    :loading-text="$t('btn.loading')"
                        :options.sync="options"
					    :locale="lang"
					    :hide-default-footer="dataSource.length < 1"
                    >
                        <template #[`item.result`] = "{item}">
                            <v-chip
                                small
                                :color="item.result == '成功' || item.result == 'success' ? 'primary' : 'error'"
                                :class="item.result == '成功' || item.result == 'success' ? 'primary' : 'error'"
                                class="font-weight-semibold text-capitalize"
                            >
                                {{ item.result }}
                            </v-chip>
                        </template>
                        <template v-slot:item.logTime="{ item }">
                            {{ formatDate(item.logTime) }}
                        </template>
                        <template v-slot:item.descp="{ item }">
                            <a
                                class="descp"
                                @click="showView(item)"
                                style="color: #5066e0; cursor: pointer;">
                                {{item.descp}}
                            </a>
                            <!-- <div :title="item.descp">{{ item.descp }}</div> -->
                        </template>
                        <template #[`item.actionType`] = "{item}">
                            <v-chip
                                small
                                outlined
                                :color="item.actionType == '登录' || item.actionType == 'login' ? 'green' : (item.actionType == '登出' || item.actionType == 'Logout' ? 'deep-purple' : '')"
                            >
                            {{ item.actionType }}
                            </v-chip>
                        </template>
                        <!-- <span slot="actionType-column" slot-scope="text, record">
                            <a-tag color="blue" v-if="text == '登录' || text == 'login'">
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '登出' || text == 'Logout'" color="orange" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '绑定' || text == 'bind'" color="red" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '修改' || text == 'modify'" color="green" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '重置' || text == 'reset'" color="cyan" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '解绑' || text == 'unbind'" color="purple" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '激活' || text == 'activate'" color="pink" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '访问' || text == 'visit'" color="orange" >
                                {{text}}
                            </a-tag>
                            <a-tag  v-else-if="text == '发送' || text == 'send'" color="purple" >
                                {{text}}
                            </a-tag>
                       </span> -->
                    </v-data-table>
                    <div v-if="dataSource.length < 1" class="text-center pb-10">
                        <img src="@/assets/img/null.png" alt="">
                        <div style="color: #999;">{{$t('adhibition.noData')}}</div>
                    </div>
                </div>
            </div>
        </v-card>
		<VDetails
            v-if="detailsVisible"
            :visible="detailsVisible"
            :infoData="infoData"
            @handleCancel="detailsCancel"
            @input="v=>{detailsVisible=v}">
        </VDetails>

        <!-- </a-spin> -->
    </div>
</template>

<script>
import { logList } from "@/api/index";
import moment from 'moment';
import VDetails from './details' // 详情
import store from '@/store'

export default {
	components: { VDetails },
    data() {
        return {
            objData: {},
            dataSource: [],
            columns: [],
            datePicker:{
                startTime: "",
                endTime: ""
            },
            lang:"",
            menu2: false,
            menu1: false,
            TableTotal:0,
            options: {
          sortBy: ['id'],
          sortDesc: [true],
            　　page:1,
             itemsPerPage:20,
			},
            selectType: [
                { value: this.$t('log.selectType.type01'), key: '' },
                { value: this.$t('log.selectType.type02'), key: 1001 },
                // { label: '注册', value: 1002 },
                { value: this.$t('log.selectType.type03'), key: 1004 },
                { value: this.$t('log.selectType.type04'), key: 1007 },
                { value: this.$t('log.selectType.type05'), key: 1008 },
                { value: this.$t('log.selectType.type06'), key: 1010 },
                // { label: '认证', value: 1011 },
                // { label: '设置', value: 1013 },
                { value: this.$t('log.selectType.type07'), key: 1014 },
                { value: this.$t('log.selectType.type08'), key: 1015 },
                { value: this.$t('log.selectType.type09'), key: 1016 },
                { value: this.$t('log.selectType.type10'), key: 1017 },
                { value: this.$t('log.selectType.type11'), key: 1009 },
                { value: this.$t('log.selectType.type12'), key: 1018 },
                { value: this.$t('log.selectType.type13'), key: 1019 },
                { value: this.$t('log.selectType.type20'), key: 1020 },
                { value: this.$t('log.selectType.type21'), key: 1021 },
                // { value: this.$t('log.selectType.type14'), key: 2000 },
                { value: this.$t('log.selectType.type15'), key: 2001 },
                { value: this.$t('log.selectType.type16'), key: 2002 },
                { value: this.$t('log.selectType.type17'), key: 2003 },
                { value: this.$t('log.selectType.type18'), key: 2004 },
                { value: this.$t('log.selectType.type19'), key: 2005 },
                { value: this.$t('log.selectType.type22'), key: 2008 },
                

            ],
            resultType: [
                { value: this.$t('log.resultType.label01'), key: '' },
                { value: this.$t('log.resultType.label02'), key: 1 },
                { value: this.$t('log.resultType.label03'), key: 0 },
            ],
            spinning: false,
            searchFilter:{
              pageNum:1,
              pageSize:20
            },
            detailsVisible: false,
            infoData: {}
        }
    },

    created() {
        this.lang = this.$i18n.locale

        this.columns = [
            {
                text: this.$t('log.columns.descp'),
                value: 'descp',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
			    text: this.$t('log.columns.logTime'),
			    value: 'logTime',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
			    text: this.$t('log.columns.actionType'),
                value: 'actionType',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.actionObject'),
                value: 'actionObject',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.device'),
                value: 'device',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.browser'),
                value: 'browser',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.location'),
                value: 'location',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.ip'),
                value: 'ip',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
            {
                text: this.$t('log.columns.result'),
                value: 'result',
                align: "center",
                ellipsis: true,
			    sortable: false,
            },
        ]
        // let createdData = {
        //     pageNum: 1,
        //     pageSize: 20,
        // }
        // this.getData(createdData)
    },
    watch: {
      options: {
        handler () {
          this.searchFilter.pageNum = this.options.page
          this.searchFilter.pageSize = this.options.itemsPerPage
          this.getData( this.searchFilter)
        },
        deep: true,
      },

	},

    methods: {
		moment,
        getData(createdData) {
            this.spinning = true
            logList(createdData).then(res=> {
                this.spinning = false
                if(res.code == this.$GLOBA.StatusOK) {
                    this.dataSource = res.data.list
                    this.TableTotal = res.data.total;
                }else{
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        formatDate(value) {
            return moment(value * 1000).format('YYYY-MM-DD HH:mm:ss')
        },
        allowedStartDates(val) {
            if(this.datePicker.endTime){
                 return Date.parse(val) <= new Date(this.datePicker.endTime).getTime()
            }else{
                return Date.parse(val) < Date.now()
            }
        },
        allowedEndDates(val) {
            if(this.datePicker.startTime == ""){
                return Date.parse(val) < Date.now()
            }else{
                return Date.parse(val) >= new Date(this.datePicker.startTime).getTime() && Date.parse(val) < Date.now()
            }
        },
        handleSearch() {


          this.options.page = 1
          this.options.itemsPerPage = 20


           this.searchFilter = {
            actionType: this.objData.type,
            pageNum: 1,
            pageSize: 20,
            result: this.objData.result,
          }

            if(this.datePicker.startTime){
              this.searchFilter.startTime = moment(this.datePicker.startTime).startOf('day').unix()
            }
            if(this.datePicker.endTime){
              this.searchFilter.endTime = moment(this.datePicker.endTime).endOf('day').unix()
            }
             this.getData( this.searchFilter )
        },
        handleReset() {
            this.datePicker.startTime = ''
            this.datePicker.endTime = ""
            this.objData = {}
            this.options.page = 1
            this.options.itemsPerPage = 20
            this.searchFilter = {
                pageNum: 1,
                pageSize: 20,
            }
            this.getData(this.searchFilter)
        },
		showView(val) {
			this.infoData = val
			this.detailsVisible = true
		},
		detailsCancel() {
			this.detailsVisible = false
		},
    },
}
</script>

<style lang='scss' scoped>
.search-box {
    // background: #FFFFFF;
    box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    // padding: 0px 0px 20px;
    // margin-bottom: 10px;
    .sub-title {
        font-size: 18px;
        font-weight: 600;
        padding: 8px 0 8px 30px;
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 6px 6px 0 0;
        margin-bottom: 30px;
        span {
            margin-left: 10px;
        }
    }
    .sub-title-l {
      background: #dce0f9;
      color: #333;
    }
    .sub-title-d {
      border-bottom: 1px solid #f0f0f0;
    }
    .title {
        padding-bottom: 30px;
    }
    .box {
        display: flex;
        .s-list {
            margin-right: 20px;
            display: flex;
            align-items: center;
            .label {
                width: 100px;
                text-align: right;
            }
            .select-flex {
                width: 200px;
            }
        }
    }
}
.table-box ::v-deep {
    // background: #FFFFFF;
    // box-shadow: 0px 0px 46px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 20px 20px 0px 20px;
    // margin-top: 30px;
    .ant-table-small {
        border: 0;
    }
    .ant-table-small > .ant-table-content .ant-table-header {
        background: rgb(220 224 249 / 25%);
        color: #333;
        font-size: 14px;
    }
    .ant-table-tbody .ant-table-row:nth-child(2n) {
        background: #fbfbfb;
    }
    .ant-table-small > .ant-table-content .ant-table-row:last-child td {
        border-bottom: 1px solid #e8e8e8;
    }
}
::v-deep{
    .ant-btn-primary{
        background: #5066e0;
    }
    .ant-pagination-item-active{
        border-color: #5066e0;
    }
    .ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
        border-color: #5066e0;
    }
    .ant-calendar-time-picker-btn{
        color: #5066e0;
    }
    .ant-calendar .ant-calendar-ok-btn{
        background: #ccc !important;
    }
    .ant-tag-purple{
        color: #4c61d3;
        background: #f9f0ff;
        border-color: #dce0f9;
    }
}
::v-deep {
    .v-data-table__wrapper{
        height: calc(100% - 47px);
        overflow: auto;
    }
}
.descp {
    max-width: 200px;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
}
</style>
